if (!customElements.get('rw-product-information')) {
  customElements.define('rw-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const source = this.querySelector('[data-preorder-source]');
      const details = this.querySelector('[data-product-details]');
      if (!source || !details) return;

      const nodes = Array.from(source.childNodes);
      const heading = (node) => (node.textContent || '').replace(/\*/g, '').trim();
      const start = nodes.findIndex(node => /^(pre[ -]?order (information|details|terms))$/i.test(heading(node)));
      // Unknown formats remain fully visible; never guess or hide payment/fulfillment terms.
      if (start === -1) return;
      let end = nodes.length;
      for (let index = start + 1; index < nodes.length; index++) {
        if (/^(shipping|product (details|features)|materials|fit|care( instructions)?)$/i.test(heading(nodes[index]))) {
          end = index;
          break;
        }
      }
      details.replaceChildren();
      nodes.forEach((node, index) => {
        if (index < start || index >= end) details.append(node);
      });
    }
  });
}
